export type ColorMode = "light" | "dark";

export const COLOR_MODE_COOKIE = "color-mode";

const ONE_YEAR_SECONDS = 60 * 60 * 24 * 365;

export function isColorMode(value: string | undefined | null): value is ColorMode {
  return value === "light" || value === "dark";
}

export function readColorMode(cookie = readDocumentCookie()): ColorMode {
  const parts = cookie.split(";");
  for (let index = 0; index < parts.length; index++) {
    const piece = parts[index].split("=");
    const name = piece[0] ? piece[0].trim() : "";
    const value = piece.length > 1 ? piece.slice(1).join("=").trim() : "";
    if (name === COLOR_MODE_COOKIE && isColorMode(value)) {
      return value;
    }
  }
  return "light";
}

export function colorModeCookie(mode: ColorMode, secure: boolean): string {
  const secureFlag = secure ? "; Secure" : "";
  return `${COLOR_MODE_COOKIE}=${mode}; Path=/; Max-Age=${ONE_YEAR_SECONDS}; SameSite=Lax${secureFlag}`;
}

export function applyColorMode(mode: ColorMode): void {
  const root = document.documentElement;
  root.classList.toggle("dark", mode === "dark");
  root.style.colorScheme = mode;
  const theme = document.querySelector('meta[name="theme-color"]');
  if (theme) {
    theme.setAttribute("content", mode === "dark" ? "#111827" : "#ffffff");
  }
}

export function writeColorMode(mode: ColorMode): void {
  const secure = window.location.protocol === "https:";
  document.cookie = colorModeCookie(mode, secure);
  applyColorMode(mode);
}

function readDocumentCookie(): string {
  if (typeof document === "undefined") {
    return "";
  }
  return document.cookie;
}
